import * as LocalAuthentication from "expo-local-authentication";
import { BaseToast, ErrorToast } from "react-native-toast-message";
import { urlApi, getApiUrl } from "../Api";
import { Platform } from "react-native";

export const MAP_REGION_INITIAL = {
  latitude: -23.565581939429435,
  longitude: -46.65125936001952,
  latitudeDelta: 0.0,
  longitudeDelta: 0.08,
}; // Initial region map

export const CIRCLE_RADIUS_INITIAL = 3000; //Initial Circle radius of device local marker
export const LONGITUDE_DELTA = 0.07; //Defines zoom of maps
export const LATITUDE_DELTA = 0.1; //Defines zoom of maps
export const mapDeltaUnityDetails = {
  latitudeDelta: 0.003,
  longitudeDelta: 0.003,
};
export const IS_IOS = Platform.OS === "ios";
export const IS_WEB = Platform.OS === "web";

export const getDayofWeek = (dayNumber) => {
  switch (dayNumber) {
    case 0:
      return "Domingo";
    case 1:
      return "Segunda";
    case 2:
      return "Terça";
    case 3:
      return "Quarta";
    case 4:
      return "Quinta";
    case 5:
      return "Sexta";
    case 6:
      return "Sabado";
  }
  return "Não encontrado";
};

export const apiCredentials = {
  usernameAPI: "Softcase",
  password: "49D0F59BD0B6691FD962BE079F5A1F9B713CE23E3981FC10BF8232930499C0FC",
};

export function onAuthenticate(setIsAuthenticate) {
  const auth = LocalAuthentication.authenticateAsync({
    promptMessage: "Autentique-se",
    fallbackLabel: "Coloque a senha",
  });
  auth.then((result) => {
    setIsAuthenticate(result.success);
  });
}

export const urlApp = "https://www.estacionamentostrevo.com.br/";
// export const urlPrivacity = "https://www.estacionamentostrevo.com.br/compromisso-social/politicadeprivacidade"
export const urlPrivacity = getApiUrl("/api/v1/File?fileName=Politica_de_privacidade.pdf")
export const urlTermsOfUse = getApiUrl("/api/v1/File?fileName=Termos_de_uso.pdf")
export const supportMail = "suporte@softcasenet.com.br"

export const APP_STORE_URL = "https://apps.apple.com/br/app/trevo-estacionamentos/id6443782726";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.softpark.trevoapp";

export const contacts = {
  address:
    "Rua Palestra Itália, 73 - 15º andar\nPerdizes / São Paulo - SP\n05005-030 - Brasil",
  tellphone: "1131061456",
  mail: "sac@estacionamentostrevo.com.br",
  contactUs: "https://www.estacionamentostrevo.com.br/contato/fale-conosco",
  geo: {
    latitude: "-23.529078396686",
    longitude: "-46.678384192299895",
  },
  whatsapp: "11996522643"
};

export const googleMapsAPIKey = "AIzaSyCEMsrquRWHxO5F1OHGR2mRBPP6KdZzLJQ"

export const toastConfig = {
  /*
      Overwrite 'success' type,
      by modifying the existing `BaseToast` component
    */
  success: (props) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: "pink" }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{
        fontSize: 15,
        fontWeight: "400",
      }}
    />
  ),
  /*
      Overwrite 'error' type,
      by modifying the existing `ErrorToast` component
    */
  error: (props) => (
    <ErrorToast
      {...props}
      text1Style={{
        fontSize: 17,
      }}
      text2Style={{
        fontSize: 15,
      }}
    />
  ),
};

export const COLOR_VEHICLES = [
  { name: "BRANCO", hex: "#ffffff" },
  { name: "PRATA", hex: "#c0c0c0" },
  { name: "PRETO", hex: "#000000" },
  { name: "CINZA", hex: "#8f847d" },
  { name: "VERMELHO", hex: "#c4342d" },
  { name: "AZUL", hex: "#0e4bef" }, 
]
